<script setup lang="ts">
import { NMessageProvider, NSpin, NConfigProvider, lightTheme, NDialogProvider } from 'naive-ui'
import MainContent from './pages/MainContent.vue'
import { useHallApi, useLoading } from '@99fun-agent/hooks'
import { useSiteStore } from '@99fun-agent/stores'

const { isLoading, switchLoading } = useLoading()
const { setShowLoadingProxy } = useHallApi()
setShowLoadingProxy((show) => {
  switchLoading(show)
})

const spinThemeOverrides = {
  color: '#9e2ff3',
}

const siteStore = useSiteStore()
siteStore.getConfigs()
</script>

<template>
  <!-- <div>123</div> -->
  <NConfigProvider :theme="lightTheme">
    <NDialogProvider>
      <NMessageProvider>
        <NSpin :show="isLoading" :theme-overrides="spinThemeOverrides">
          <MainContent></MainContent>
        </NSpin>
      </NMessageProvider>
    </NDialogProvider>
  </NConfigProvider>
</template>

<style scoped></style>
